import { Environment } from 'app/utils';
import { apolloService } from 'app/services';
import { SIMPLE_AUTH_TOKEN_QUERY } from 'app/gql';

export const validateToken = async ( token, environment = Environment.LOCAL ) => {
    const response = await apolloService.query( { variables: { token, environment }, fetchPolicy: 'no-cache', query: SIMPLE_AUTH_TOKEN_QUERY } );
    return response.data.simpleAuth.success;
};
